import type {
  ExtendedResource,
  ExtendedResourceConstructor,
} from '@seen/core/ExtendedResource'
import type { QueryTypes } from '@seen/core/search'
import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query'
import { useMedplum } from '#src/hooks/useMedplum.ts'
import { searchOptions } from '#src/query-options/searchOptions.ts'

export function useSuspenseSearch<T extends ExtendedResource>(
  resourceClass: ExtendedResourceConstructor<T>,
  query: QueryTypes
): UseSuspenseQueryResult<T[]> {
  const medplum = useMedplum()
  const queryOptions = searchOptions(medplum, resourceClass, query)
  return useSuspenseQuery(queryOptions)
}
